/* eslint-disable default-case */
const { produce } = immer;

const SCOPES = {
    AVERAGE: 'seasonAverage',
    TOTAL: 'seasonTotal',
    MATCH: 'currentMatch'
};

export const updateData = (state, action) => {
    return produce(state, (draft) => {
        switch (action.payload.type) {
            case 'coach': {
                // Display Possession %, Biggest Lead, and Last Goal statistics
                const matchId = action.payload.options.matchId;
                const possession = action.payload.json.possession;
                const scoreDetails =
                    action.payload.json.scoreDetails.scoreDetails;

                if (!draft[matchId]) {
                    draft[matchId] = {};
                }

                if (!draft[matchId].possession) {
                    draft[matchId].possession = {};
                }

                draft[matchId].possession.periodInDisputePerc =
                    possession.periodInDisputePerc;
                draft[matchId].possession.last10InDisputePerc =
                    possession.last10InDisputePerc;
                draft[matchId].possession.matchInDisputePerc =
                    possession.matchInDisputePerc;
                draft[matchId].possession.homeTeam = {
                    ...draft[matchId].possession.homeTeam,
                    ...possession.squadPossessionList[0]
                };
                draft[matchId].possession.awayTeam = {
                    ...draft[matchId].possession.awayTeam,
                    ...possession.squadPossessionList[1]
                };

                if (!draft[matchId].scoreDetails) {
                    draft[matchId].scoreDetails = {};
                }

                draft[matchId].scoreDetails.homeTeam = scoreDetails[0];
                draft[matchId].scoreDetails.awayTeam = scoreDetails[1];

                if (!draft[matchId].requestsComplete) {
                    draft[matchId].requestsComplete = 1;
                } else {
                    draft[matchId].requestsComplete = draft[
                        matchId
                    ].requestsComplete += 1;
                }

                break;
            }
            case 'season': {
                // Display Season Totals and Season AVGs
                const matchId = action.payload.options.matchId;
                const options = action.payload.options;
                const seasonStats = action.payload.json.lists;

                seasonStats.forEach((item) => {
                    const teamId = item.team.teamId;
                    const homeOrAway =
                        teamId === options.homeTeamId ? 'homeTeam' : 'awayTeam';

                    _addStats(
                        draft,
                        matchId,
                        item.stats.averages,
                        SCOPES.AVERAGE,
                        homeOrAway
                    );
                    _addStats(
                        draft,
                        matchId,
                        item.stats.totals,
                        SCOPES.TOTAL,
                        homeOrAway
                    );
                });

                if (!draft[matchId]) {
                    draft[matchId] = {};
                }

                if (!draft[matchId].requestsComplete) {
                    draft[matchId].requestsComplete = 1;
                } else {
                    draft[matchId].requestsComplete = draft[
                        matchId
                    ].requestsComplete += 1;
                }

                if (!draft[matchId].seasonStatsRequestComplete) {
                    draft[matchId].seasonStatsRequestComplete = true;
                }

                break;
            }
            case 'match': {
                // Add current match stats to the store
                const matchId = action.payload.options.matchId;
                const options = action.payload.options;
                const matchStats = action.payload.json.teamStats;

                matchStats.forEach((team) => {
                    const teamId = team.teamId;
                    const homeOrAway =
                        teamId === options.homeTeamId ? 'homeTeam' : 'awayTeam';

                    _addStats(
                        draft,
                        matchId,
                        team.stats,
                        SCOPES.MATCH,
                        homeOrAway
                    );
                });

                if (!draft[matchId]) {
                    draft[matchId] = {};
                }

                if (!draft[matchId].requestsComplete) {
                    draft[matchId].requestsComplete = 1;
                } else {
                    draft[matchId].requestsComplete = draft[
                        matchId
                    ].requestsComplete += 1;
                }

                break;
            }
            case 'failed': {
                const matchId = action.payload.options.matchId;
                const requestType = action.payload.requestType;

                if (!draft[matchId]) {
                    draft[matchId] = {};
                }

                if (!draft[matchId].requestsFailed) {
                    draft[matchId].requestsFailed = {};
                }

                draft[matchId].requestsFailed[requestType] = null;

                if (!draft[matchId].requestsComplete) {
                    draft[matchId].requestsComplete = 1;
                } else {
                    draft[matchId].requestsComplete = draft[
                        matchId
                    ].requestsComplete += 1;
                }

                break;
            }
        }
    });
};

const _addStats = (draft, matchId, stats, type, teamId) => {
    const items = Object.keys(stats);

    items.forEach((key) => {
        if (!draft[matchId]) {
            draft[matchId] = {};
        }

        if (!stats[key] || stats[key] === 'null') {
            draft[matchId] = _createNewObj(
                draft[matchId],
                key,
                teamId,
                type,
                '-'
            );

            return;
        }

        switch (key) {
            case 'clearances':
                // Clearances returns an object instead, this is to split it out
                Object.keys(stats[key]).forEach((item) => {
                    if (!stats[key][item] || stats[key][item] === 'null') {
                        draft[matchId] = _createNewObj(
                            draft[matchId],
                            item,
                            teamId,
                            type,
                            '-'
                        );

                        return;
                    }

                    draft[matchId] = _createNewObj(
                        draft[matchId],
                        item,
                        teamId,
                        type,
                        stats[key][item]
                    );
                });

                break;
            case 'freesFor':
                draft[matchId] = _createNewObj(
                    draft[matchId],
                    'freeKicks',
                    teamId,
                    type,
                    stats[key]
                );

                break;
            case 'totalPossessions':
                draft[matchId] = _createNewObj(
                    draft[matchId],
                    'possession',
                    teamId,
                    type,
                    stats[key]
                );
                draft[matchId] = _createNewObj(
                    draft[matchId],
                    key,
                    teamId,
                    type,
                    stats[key]
                );

                break;
            default:
                draft[matchId] = _createNewObj(
                    draft[matchId],
                    key,
                    teamId,
                    type,
                    stats[key]
                );
        }
    });

    return draft;
};

const _createNewObj = (draft, key, teamId, type, stat) => {
    if (!draft[key]) {
        draft[key] = {};
    }

    if (!draft[key][teamId]) {
        draft[key][teamId] = {};
    }

    draft[key][teamId][type] = stat;

    return draft;
};
